import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../common/PageHeader';
import Reveal from '../common/Reveal';
import { useLang, usePageTitle } from '../../i18n/LanguageContext';
import mark from '../../assets/safehand-mark.png';

export default function About() {
  const { t } = useLang();
  const a = t.about;
  usePageTitle(a.pageTitle);

  const pillars = [
    { icon: 'fa-bullseye', title: a.missionTitle, text: a.mission },
    { icon: 'fa-eye', title: a.visionTitle, text: a.vision },
    { icon: 'fa-gem', title: a.valuesTitle, text: a.values },
  ];

  return (
    <>
      <PageHeader crumb={a.pageTitle} eyebrow={a.eyebrow} title={a.title} />

      <section className="section">
        <div className="container split">
          <Reveal className="split__copy">
            <p className="section-lead section-lead--lg">{a.lead}</p>
            <p className="section-lead">{a.lead2}</p>
            <div className="studio__ctas">
              <Link to="/safehand" className="btn btn--primary">
                {t.nav.safehand} <i className="fa-solid fa-arrow-right flip-rtl" aria-hidden="true" />
              </Link>
              <Link to="/services" className="btn btn--outline">
                {t.nav.studio}
              </Link>
            </div>
          </Reveal>
          <Reveal delay={150} className="about-visual">
            <img src={mark} alt="SafeHand" width="220" height="220" />
            <div className="about-visual__ring" aria-hidden="true" />
          </Reveal>
        </div>
      </section>

      <section className="section section--tint">
        <div className="container grid grid--3">
          {pillars.map((p, i) => (
            <Reveal key={p.title} delay={i * 90} className="card card--pillar">
              <span className="icon-tile">
                <i className={`fa-solid ${p.icon}`} aria-hidden="true" />
              </span>
              <h2 className="card__title">{p.title}</h2>
              <p className="card__text">{p.text}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="stats stats--row">
            {t.studio.stats.map((st, i) => (
              <Reveal key={st.label} delay={i * 80} className="stat">
                <strong dir="ltr">{st.value}</strong>
                <span>{st.label}</span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
